/*
 * COPYRIGHT 2022,2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 *
 */

import { Component } from 'react';
import { Button } from 'yospace-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faTrashAlt, faUpload } from '@fortawesome/free-solid-svg-icons';

import { ButtonPanelStyles } from './ButtonPanelStyles';

class ButtonPanel extends Component {
    render() {
        return (
            <div style = { ButtonPanelStyles.getMain() } >
                <Button type = "icon" text = { <FontAwesomeIcon icon = { faEdit } /> } />
                <Button type = "icon" text = { <FontAwesomeIcon icon = { faEye } /> } />
                <Button type = "icon" text = { <FontAwesomeIcon icon = { faUpload } /> } />
                <Button type = "icon" text = { <FontAwesomeIcon icon = { faTrashAlt } /> } />
            </div>
        )
    }
}

export default ButtonPanel;
